import ErrorRedirectDialog from '../components/ErrorRedirectDialog';
import { ContainerSpinner } from '../components/Spinner';
import useFetch from '../hooks/api';
import OfflineTable from '../components/OfflineTable';
import { Button } from '../shadcn/Button';
import { useEffect, useState } from 'react';
import auth from '../auth';
import { useNavigate } from 'react-router-dom';
import {
	clearImpersonationSession,
	getActiveImpersonationSession,
	IMPERSONATION_DURATION_MS,
	saveImpersonationSession
} from '../utils/impersonation';

export default function LogInAs() {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const { data, error } = useFetch('https://api.krece.app/storeprofile/masteruser/', 'GET', true, undefined, setLoading);
	const [selectedEmail, setSelectedEmail] = useState('');

	const [getToken, setGetToken] = useState(false);
	const {
		data: token,
		loading: tokenLoading,
		error: tokenError,
		setPayload
	} = useFetch('https://api.krece.app/storeprofile/get_custom_token/', 'POST', getToken, undefined, setLoading);

	useEffect(() => {
		if (!token || !selectedEmail) return;

		let cancelled = false;
		const loginAsSelectedStore = async () => {
			setLoading(true);
			const originalUser = auth.currentUser;
			const activeImpersonation = getActiveImpersonationSession(originalUser?.email);
			const originalEmail = activeImpersonation?.originalEmail || originalUser?.email;
			if (!originalUser || !originalEmail) {
				setLoading(false);
				return;
			}

			const originalToken = activeImpersonation?.originalToken || (await originalUser.getIdToken(true));
			const startedAt = Date.now();
			saveImpersonationSession({
				originalEmail,
				originalToken,
				targetEmail: selectedEmail,
				startedAt,
				expiresAt: startedAt + IMPERSONATION_DURATION_MS
			});

			auth
				.signInWithCustomToken(token)
				.catch(() => {
					clearImpersonationSession();
				})
				.finally(() => {
					if (cancelled) return;
					setTimeout(() => {
						navigate('/', { replace: true });
					}, 2000);
				});
		};

		loginAsSelectedStore();
		return () => {
			cancelled = true;
		};
	}, [navigate, selectedEmail, token]);

	if (loading || !data) return <ContainerSpinner size={3} />;
	if (error || tokenError) return <ErrorRedirectDialog />;

	const headers = ['Email', 'Action'];
	const rows = data.map((email: string) => [
		email,
		<Button
			variant="primary"
			className="w-auto h-auto"
			disabled={tokenLoading}
			onClick={() => {
				setSelectedEmail(email);
				setGetToken(true);
				setPayload({ email });
			}}
		>
			Login
		</Button>
	]);

	return (
		<div className="mx-auto flex h-full max-w-5xl flex-col items-center justify-center gap-4 p-4 text-center">
			<OfflineTable headers={headers} rows={rows} />
		</div>
	);
}
